var WorkingHoursDataTestId = /* @__PURE__ */ ((WorkingHoursDataTestId2) => {
  WorkingHoursDataTestId2["TOGGLE_HOURS_BUTTON"] = "toggle-hours--branch-working-hours";
  return WorkingHoursDataTestId2;
})(WorkingHoursDataTestId || {});
export {
  WorkingHoursDataTestId
};
